import {
  filterOptionsByType,
  OptionModel,
  OptionType,
} from '@akin-home/options';
import { MealPlanPreferences } from '@akin-home/recipes';
import { getIDs } from '@akin-home/records';

interface Params {
  preferences?: MealPlanPreferences;
  options: OptionModel[];
}

/** WIP */
/** Takes a user's meal preferences and produces the corresponding options to be used for filtering */
export const getRecipeFilterOptionsFromUserPreferences = ({
  options,
  preferences,
}: Params) => {
  const { allergies } = preferences || {};

  const include: string[] = [];
  const exclude: string[] = [];

  /** Budget will be less than or equal to the budget  */
  if (allergies?.length) {
    const allergy_options = filterOptionsByType(OptionType.ALLERGY)(options);

    const allergies_to_exclude = getIDs(
      allergy_options.filter((allergy) => allergies.includes(allergy.label))
    );

    if (allergies_to_exclude.length) {
      exclude.push(...allergies_to_exclude);
    }
  }

  return [include, exclude];
};
